import React, { useEffect, useState } from 'react';
import { Modal, Form, Alert } from 'react-bootstrap';
import ClinicalButton, { ClinicalModalActions } from '../../doctor/ui/ClinicalButton';

const DEFAULT_REASON = 'Orientation médicale requise';

export default function NurseTransferModal({ show, onHide, loading, onConfirm, patientName }) {
  const [reason, setReason] = useState(DEFAULT_REASON);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    setReason(DEFAULT_REASON);
    setError('');
  }, [show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = String(reason || '').trim();
    if (trimmed.length < 3) {
      setError('Indiquez un motif d’au moins 3 caractères.');
      return;
    }
    setError('');
    onConfirm(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered className="nr-workspace-modal">
      <Modal.Header closeButton className="nr-workspace-modal__header">
        <Modal.Title>Transférer vers le médecin</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {patientName ? (
            <p className="text-muted small mb-3">
              Patient : <strong>{patientName}</strong> — le passage sera orienté vers la file médecin.
            </p>
          ) : null}
          {error ? <Alert variant="danger">{error}</Alert> : null}
          <Form.Group>
            <Form.Label>Motif du transfert</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={loading}
              placeholder="Ex. aggravation des symptômes, besoin d’avis médical…"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <ClinicalModalActions>
            <ClinicalButton variant="secondary" onClick={onHide} disabled={loading}>
              Annuler
            </ClinicalButton>
            <ClinicalButton variant="primary" type="submit" loading={loading} icon="arrowRight">
              Confirmer le transfert
            </ClinicalButton>
          </ClinicalModalActions>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
